import {Pipe, PipeTransform} from "@angular/core";
import { environment } from "@wms/app";

@Pipe({ name: 'versionManager', standalone: true })
export class VersionManagerPipe implements PipeTransform {

  /**
   * if nothing passed, it will just return the cdnUrl
   * or else cdn url with build number is prepended and returned
   * @param assetPath
   */
  transform(assetPath: string): string {
    assetPath = assetPath.startsWith("/") ? assetPath.substring(1) : assetPath;
    return environment.CDN_BASE_URL && environment.CDN_BASE_URL !== "" ? environment.CDN_BASE_URL + assetPath : assetPath;
  }
}
